/*
 * This is being used by the Data Analyst team.
*/

const snowplow = {
  load() {
    (function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
    p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
    };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
    n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//d1fc8wv8zag5ca.cloudfront.net/2.4.2/sp.js","snowplow"));

    var collectorUrls = ["events.fivetran.com/snowplow/rrkjm7cnask2"];
    var trackingOptions = { appId: 'sk-marketing', cookieDomain: null };

    collectorUrls.forEach(function(collectorUrl, index) {
    var trackerNamespace = 'javascript:marketing';
    window.snowplow('newTracker', trackerNamespace, collectorUrl, trackingOptions);
    });

    window.snowplow('enableActivityTracking', 30, 10);
    window.snowplow('trackPageView');
  }
}

export default snowplow;
